<!-- Week selector -->
<div class="row mb-2">
  <div class="col-12 col-md-4">
    <select class="form-select form-select-sm"
            [(ngModel)]="gridFilters.timeWeekKey"
            (ngModelChange)="onWeekSelectChange($event)">
      <option value="">-- Choose Week --</option>
      <option *ngFor="let w of listTimeWeeks; trackBy: trackByFn" [value]="w.id">
        Week {{ w.wk }}: {{ w.wkstart }} - {{ w.wkend }}
      </option>
    </select>
  </div>
</div>

<!-- Time Entry Modal -->
<div class="modal fade"
     [class.show]="showEntryModal"
     [ngStyle]="{ display: showEntryModal ? 'block' : 'none' }"
     tabindex="-1"
     (click)="onModalBackdropClick($event)">
  <div class="modal-dialog modal-lg modal-dialog-centered" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Time Entry</h5>
        <button type="button"
                class="btn-close"
                aria-label="Close"
                (click)="closeEntryModal()"></button>
      </div>
      <div class="modal-body">
        <!-- Your existing Form Entry component (now inside the modal) -->
        <app-form-entry #ctlEntryCalendar></app-form-entry>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop -->
<div class="modal-backdrop fade"
     *ngIf="showEntryModal"
     [class.show]="showEntryModal">
</div>

<!-- Calendar -->
<div class="row mb-2">
  <div class="col-12">
    <div id="calendar">
      <full-calendar #calendar [options]="calendarOptions"></full-calendar>
    </div>
  </div>
</div>
